/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';

import { deleteLibraryItem } from 'redux/actions';

export const DeleteLibraryItemModal = ({ deleteId, setDeleteId }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      title="Delete"
      visible={deleteId !== null}
      onCancel={() => setDeleteId(null)}
      footer={[
        <Button key="cancel" onClick={() => setDeleteId(null)}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          onClick={() => {
            setDeleteId(null);
            dispatch(deleteLibraryItem(deleteId));
          }}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      Are you sure you want to delete?
    </Modal>
  );
};
